"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEligibilityResponseToJSON = exports.GetEligibilityResponseFromJSONTyped = exports.GetEligibilityResponseFromJSON = exports.instanceOfGetEligibilityResponse = void 0;
var runtime_1 = require("../runtime");
var HoldoutLevel_1 = require("./HoldoutLevel");
var ValidatedEligibilityCampaign_1 = require("./ValidatedEligibilityCampaign");
var ValidatedEligibilityDataSurveySchedule_1 = require("./ValidatedEligibilityDataSurveySchedule");
/**
 * Check if a given object implements the GetEligibilityResponse interface.
 */
function instanceOfGetEligibilityResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetEligibilityResponse = instanceOfGetEligibilityResponse;
function GetEligibilityResponseFromJSON(json) {
    return GetEligibilityResponseFromJSONTyped(json, false);
}
exports.GetEligibilityResponseFromJSON = GetEligibilityResponseFromJSON;
function GetEligibilityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'markets': !(0, runtime_1.exists)(json, 'markets') ? undefined : json['markets'],
        'languages': !(0, runtime_1.exists)(json, 'languages') ? undefined : json['languages'],
        'disableHoldoutLevel': !(0, runtime_1.exists)(json, 'disable_holdout_level') ? undefined : (json['disable_holdout_level'].map(HoldoutLevel_1.HoldoutLevelFromJSON)),
        'surveySchedule': !(0, runtime_1.exists)(json, 'survey_schedule') ? undefined : (0, ValidatedEligibilityDataSurveySchedule_1.ValidatedEligibilityDataSurveyScheduleFromJSON)(json['survey_schedule']),
        'errorCodes': !(0, runtime_1.exists)(json, 'error_codes') ? undefined : json['error_codes'],
        'eligibilityCampaigns': !(0, runtime_1.exists)(json, 'eligibility_campaigns') ? undefined : (json['eligibility_campaigns'].map(ValidatedEligibilityCampaign_1.ValidatedEligibilityCampaignFromJSON)),
    };
}
exports.GetEligibilityResponseFromJSONTyped = GetEligibilityResponseFromJSONTyped;
function GetEligibilityResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'markets': value.markets,
        'languages': value.languages,
        'disable_holdout_level': value.disableHoldoutLevel === undefined ? undefined : (value.disableHoldoutLevel.map(HoldoutLevel_1.HoldoutLevelToJSON)),
        'survey_schedule': (0, ValidatedEligibilityDataSurveySchedule_1.ValidatedEligibilityDataSurveyScheduleToJSON)(value.surveySchedule),
        'error_codes': value.errorCodes,
        'eligibility_campaigns': value.eligibilityCampaigns === undefined ? undefined : (value.eligibilityCampaigns.map(ValidatedEligibilityCampaign_1.ValidatedEligibilityCampaignToJSON)),
    };
}
exports.GetEligibilityResponseToJSON = GetEligibilityResponseToJSON;
